/* eslint-disable @angular-eslint/component-selector */
import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
    selector: '[luiMenuButton]',
    templateUrl: './menu-button.component.html',
    standalone: false
})
export class MenuButtonComponent {
  @Input() open!: boolean;

  @HostBinding('attr.aria-label') @Input() label = 'Main menu';

  @Output() toggle = new EventEmitter<void>();

  @HostBinding('class') className = 'menu-button';

  @HostBinding('attr.role') roleAttr = 'button';

  @HostBinding('attr.tabindex') tabindex = 0;

  @HostBinding('attr.aria-expanded') get ariaExpanded() {
    return this.open;
  }

  @HostListener('click') onClick() {
    this.toggle.emit();
  }
}
